import { path } from 'ramda';

export const getErrorCode = path(['response', 'data', 'code']);
